export function reloadSelfOrSignalParent() {
    if (window.parent) {
        window.parent.postMessage({type: "reload"}, "*");
    } else {
        window.location.reload();
    }
}
